export default "__VITE_ASSET__DtsxLM4z__"